import { NavLink } from "react-router-dom";
import { Home, Search, PlusCircle, Heart, User } from "lucide-react";
import { PUBLIC_PATHS, USER_PATHS } from "@router/paths";

/**
 * BottomNav — the five-tab mobile navigation shell, mounted once by the
 * root layout (Phase 4). The center "Add Property" tab is visually
 * elevated per the approved UX/UI spec (primary product CTA pattern).
 *
 * @param {number} unreadMessagesCount — shown as a dot on Profile until a dedicated badge is needed
 * @param {number} favoritesCount
 */
const NAV_ITEMS = [
  { to: PUBLIC_PATHS.HOME, icon: Home, label: "Bosh sahifa", end: true },
  { to: PUBLIC_PATHS.SEARCH, icon: Search, label: "Qidiruv" },
  { to: USER_PATHS.ADD_PROPERTY, icon: PlusCircle, label: "", isCenter: true },
  { to: USER_PATHS.FAVORITES, icon: Heart, label: "Sevimli" },
  { to: USER_PATHS.PROFILE, icon: User, label: "Profil" },
];

export default function BottomNav({ hasUnreadMessages = false }) {
  return (
    <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-app z-nav bg-white border-t border-brand-line pb-safe">
      <div className="flex items-center justify-around px-2 py-2">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;

          if (item.isCenter) {
            return (
              <NavLink
                key={item.to}
                to={item.to}
                aria-label="E'lon qo'shish"
                className="flex flex-col items-center -mt-6"
              >
                <span className="w-14 h-14 rounded-pill bg-gold-gradient shadow-gold-glow flex items-center justify-center">
                  <Icon size={26} className="text-white" />
                </span>
              </NavLink>
            );
          }

          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className="relative flex flex-col items-center gap-0.5 px-3 py-1"
            >
              {({ isActive }) => (
                <>
                  <Icon
                    size={21}
                    className={isActive ? "text-brand-primary" : "text-brand-muted"}
                    fill={isActive && item.to === USER_PATHS.FAVORITES ? "currentColor" : "none"}
                  />
                  <span
                    className={[
                      "text-[10px]",
                      isActive ? "text-brand-primary font-bold" : "text-brand-muted font-medium",
                    ].join(" ")}
                  >
                    {item.label}
                  </span>
                  {item.to === USER_PATHS.PROFILE && hasUnreadMessages && (
                    <span className="absolute top-0 right-2 w-2 h-2 rounded-pill bg-brand-gold" />
                  )}
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
